import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ApiService, PaymentRequestQueryType, PaymentRequestDTO } from "../../../../../projects/accounting/src/public_api";
import { DecimalPipe, DatePipe } from "@angular/common";
import { DataTableComponent } from '../../../../../projects/jv-ui/src/lib/controls/data-table/data-table.component';
import { MonthSelectorComponent } from '../../ui/month-selector/month-selector.component';

@Component({
  selector: 'controller-expenses',
  templateUrl: './expenses.component.html',
  styleUrls: ['./expenses.component.scss']
})
export class ExpensesComponent {

  @ViewChild(DataTableComponent)
  private dataTable: DataTableComponent;

  @ViewChild(MonthSelectorComponent)
  private monthSelector: MonthSelectorComponent;

  constructor(
    private api: ApiService,
    private decimal: DecimalPipe,
    private date: DatePipe
  ) {
  }

  period: string;
  type: PaymentRequestQueryType = PaymentRequestQueryType.byArrival;

  public loading = false;
  public dtConfig = {
    data: [],

    xls: i => i == null
      ? ['Ngày', 'Chi tới', 'Kỳ công nợ', 'AHA', 'SCOOPS', 'MSB', '#']
      : [i.date, i.receiver, i.period, i.techcombank_aha, i.techcombank_scoops, i.msb, i.others],

    txt: i => i.receiver,

    title: 'THỐNG KÊ TIỀN CHI CÔNG NỢ THEO NGÂN HÀNG',

    group: i => {

      let parts = i.receiver.split(',');

      return { parent: "Tất cả", html: parts[parts.length - 1] }
    },

    columns: [
      {
        title: 'Ngày',
        class: 'text-left',
        html: i => '<b>' + i.date + '</b>',
        css: i => 'text-left text-info'
      },
      {
        title: 'Chi tới',
        html: function (i) {

          let first = i.receiver.substr(0, Math.max(i.receiver.indexOf(')') + 1, i.receiver.indexOf(',')));
          return '<b>' + first + '</b><br><small>' + i.receiver.substr(first.length + 1) + '</small>';
        },
      },
      {
        title: 'Kỳ công nợ',
        class: 'text-center',
        html: i => i.period,
        css: i => 'text-center',
      },
      {
        title: 'AHA',
        class: 'text-right',
        html: i => i.techcombank_aha > 0 ? this.decimal.transform(i.techcombank_aha, '1.0-0', 'en-US') : '',
        css: i => 'text-right text-danger',
      },
      {
        title: 'SCOOPS',
        class: 'text-right',
        html: i => i.techcombank_scoops > 0 ? this.decimal.transform(i.techcombank_scoops, '1.0-0', 'en-US') : '',
        css: i => 'text-right text-danger',
      },
      {
        title: 'MSB',
        class: 'text-right',
        html: i => i.msb > 0 ? this.decimal.transform(i.msb, '1.0-0', 'en-US') : '',
        css: i => 'text-right text-danger'
      },
      {
        title: '#',
        class: 'text-right',
        html: i => i.others > 0 ? this.decimal.transform(i.others, '1.0-0', 'en-US') : '',
        css: i => 'text-right text-danger'
      },
      {
        title: 'Tổng',
        class: 'text-right',
        html: i => '<b>' + this.decimal.transform(i.techcombank_aha + i.techcombank_scoops + i.msb + i.others, '1.0-0', 'en-US') + '</b>',
        css: i => 'text-right text-danger'
      },
    ],

    footer: data => {

      let techcombank_aha = 0;
      let techcombank_scoops = 0;
      let msb = 0;
      let others = 0;

      data.forEach(i => {
        techcombank_aha += i.techcombank_aha;
        techcombank_scoops += i.techcombank_scoops;
        msb += i.msb;
        others += i.others;
      });

      return [
        { html: '<b>TỔNG</b>' },
        { html: '' },
        { html: '' },
        { html: this.decimal.transform(techcombank_aha, '1.0-0', 'en-US'), class: 'text-right text-danger' },
        { html: this.decimal.transform(techcombank_scoops, '1.0-0', 'en-US'), class: 'text-right text-danger' },
        { html: this.decimal.transform(msb, '1.0-0', 'en-US'), class: 'text-right text-danger' },
        { html: this.decimal.transform(others, '1.0-0', 'en-US'), class: 'text-right text-danger' },
        {
          html: '<b>' + this.decimal.transform(techcombank_scoops + techcombank_aha + msb + others, '1.0-0', 'en-US') + '</b>',
          class: 'text-right text-danger'
        },
      ];
    }
  };

  private test(notes) {

    let parts = notes.split(' ');

    if (parts.length != 4) return false;
    if (!/([0-9]{2})\-([0-9]{2})\-([0-9]{4}) ([a-zA-Z_#]+) ([0-9\.]+) ([0-9]{2})\-([0-9]{4})/.test(notes)) return false;
    if (this.type == PaymentRequestQueryType.byArrival && notes.substr(3, 7) == this.period) return true;
    if (this.type == PaymentRequestQueryType.forPeriod && notes.substr(notes.length - 7) == this.period) return true;
    return false;
  }

  load() {

    this.loading = true;

    let request: PaymentRequestDTO = {
      Period: this.period,
      Type: this.type
    };

    this.api.paidToVendors(request).subscribe(vrs => {

      if (vrs.succeed) {

        this.api.paidToServices(request).subscribe(srs => {

          if (srs.succeed) {

            srs.data.forEach(service => service.Payments.forEach(payment => {

              payment.Receiver = service.Name + ", Thanh toán dịch vụ";
              vrs.data.push(payment);

            }));

            let buffer = {};

            vrs.data.forEach(i => {

              if (this.test(i.Notes)) {

                let key = i.Notes + " " + i.Receiver;
                let parts = i.Notes.split(' ');

                let sort = parts[0].split('-');

                if (typeof buffer[key] == "undefined") buffer[key] = {
                  amount: 0,
                  receiver: i.Receiver,
                  date: parts[0],
                  period: parts[3],
                  sort: sort[2] + sort[1] + sort[0] + ' ' + parts[3],
                  techcombank_aha: 0,
                  techcombank_scoops: 0,
                  msb: 0,
                  others: 0
                };

                buffer[key][parts[1] == '#' ? 'others' : parts[1].toLowerCase()] += i.Amount;
              }else{
                // console.log(i);
              }
            });

            let data = [];

            for (let o in buffer) data.push(buffer[o]);

            this.dtConfig.data = data.sort((a, b) => a.sort > b.sort ? 1 : -1);

            if (typeof this.dataTable != "undefined") this.dataTable.data = this.dataTable.filtered = data;

            this.loading = false;

          }
        });
      }
    });
  }
}
